<template>
  <section :class="{'business-style': isBusinessAvatar, 'event-loading': eventLoading}" class="hero is-fullheight join-event">
    <div class="hero-body">
      <div v-show="eventLoading" class="container flex-row">
        <div class="form-wrap login" style=" width: 328px; height: 550px; position: absolute;">
          <b-loading :is-full-page="false" :active="true" />
        </div>
      </div>
      <transition name="fade">
        <div v-show="!eventLoading" class="container flex-row">
          <div v-if="isModerator" class="form-wrap login">
            <img class="logo" src="/swf-logo-dark.svg">
            <div class="title is-4">Welcome, host!</div>
            <p style="font-size: .95em; margin-top:-15px; margin-bottom: 30px;">Would you like to {{ hostHasPreviousActivePlayer ? 'continue playing' : 'play along' }} or host the event from this window?</p>

            <div class="buttons m-t-40">
              <template v-if="hostHasPreviousActivePlayer">
                <div @click="joinHostAsPreviousPlayer()" class="button is-primary join-btn is-medium is-fullwidth">
                  Play as
                  <span class="inline-player">
                    <img v-if="showAvatar" :class="'style-' + avatarStyle" :src="activePlayer.avatar">
                    {{ activePlayer.name }}
                  </span>
                </div>
                <p class="is-small m-b-30 has-text-centered" style="width:100%">Re-join with your previous player</p>
              </template>
              <template v-else>
                <div @click="setHostAsPlayer()" class="button is-primary join-btn is-medium is-fullwidth">Join <b>&nbsp;{{ shortcode }}&nbsp;</b> as Player</div>
                <p class="is-small m-b-30 has-text-centered" style="width:100%">Play along and respond to questions</p>
              </template>
              <br>
              <div @click="joinAsHost()" class="button is-primary join-btn is-medium is-fullwidth">Host event <b>&nbsp;{{ shortcode }}&nbsp;</b></div>
              <p class="is-small m-b-30 has-text-centered" style="width:100%">Advance slides and control settings</p>

              <hr>
              <div v-if="hostHasPreviousActivePlayer" @click="setHostAsPlayer()" class="button is-text is-fullwidth prev-player">Join as a new player</div>
            </div>
          </div>
          <div v-else :class="{redirecting}" class="form-wrap login">
            <img class="logo" src="/swf-logo-dark.svg">

            <template v-if="showName">
              <article v-if="warning" class="message error-message is-danger">
                <section class="message-body">{{ warning }}</section>
              </article>

              <b-field v-if="!hasValidCodeInUrl" label="Event Code">
                <b-input
                  ref="eventInput"
                  v-model="typedCode"
                  @input="codeUpdated()"
                  pattern="[a-zA-Z0-9]{3,10}"
                  required
                  validation-message="event codes are 3-10 letters"
                  type="text"
                />
              </b-field>

              <b-field v-if="hasSpectatorEvent" label="Join as player or spectator?" style="margin-bottom: 0.75rem;">
                <b-field>
                  <b-radio-button v-model="joinAsSpectatorString" native-value="false" size="is-small" type="is-light-blue">
                    <span>Player</span>
                  </b-radio-button>

                  <b-radio-button v-model="joinAsSpectatorString" native-value="true" size="is-small" type="is-light-blue">
                    <span>Spectator</span>
                  </b-radio-button>
                </b-field>
              </b-field>

              <b-field v-if="hasPassword && !joinAsSpectator" label="Password">
                <b-input
                  ref="passInput"
                  v-model="typedPassword"
                  required
                  type="text"
                />
              </b-field>

              <template v-if="showAvatar">
                <div class="label">Pick an Avatar</div>
                <div @click="startSelectAvatar()" :class="{'unselected': !userSelectedAvatar}" class="current-avatar">
                  <div v-if="isBusinessAvatar" class="avatar-svg-wrapper">
                    <span :style="{'mask-image': `url(${avatar})`}" class="avatar-svg-icon" />
                  </div>
                  <img v-else :src="avatar" class="avatar">
                </div>

                <div v-if="selectAvatar" class="avatar-select">
                  <p class="title is-5">Pick an avatar</p>
                  <div v-if="isBusinessAvatar" class="avatars">
                    <div v-for="emoji in allEmoji" :key="emoji" @click="pickAvatar(emoji)" class="avatar-svg-wrapper">
                      <span :style="{'mask-image': `url(${emoji})`}" class="avatar-svg-icon" />
                    </div>
                  </div>
                  <div v-else class="avatars">
                    <img v-for="emoji in allEmoji" :src="emoji" :key="emoji" @click="pickAvatar(emoji)" class="avatar">
                  </div>
                  <div @click="selectAvatar = false" class="close"><i class="fas fa-times" /></div>
                </div>
              </template>

              <b-field :class="{'name-field': shouldCollectEmail }" label="Name">
                <b-input
                  ref="nameInput"
                  v-model="name"
                  required
                  maxlength="30"
                  pattern="[a-zA-Z0-9_!@#$%&*- ]*"
                  validation-message="only alphanumeric and !@#$%&*_-"
                  type="text"
                />
              </b-field>

              <template v-if="shouldCollectEmail">
                <b-field :label="collectPlayerEmails === 'optional' ? 'Email (optional)' : 'Email'">
                  <b-input
                    ref="emailInput"
                    :required="collectPlayerEmails === 'required'"
                    :expanded="true"
                    v-model="playerEmail"
                    @input="debouncedCheckEmailSpelling()"
                    type="email"
                    class=""
                  />
                  <span v-if="suggestion" @click="setSuggestedEmail()" class="suggestion">do you mean <u>{{ suggestion }}</u>?</span>
                </b-field>
              </template>

              <div @click="startJoinEvent()" :disabled="(hostJoinedAsPlayer && joinAsSpectator) || loading || eventFull" :class="{'is-loading': loading}" class="m-t-30 join-btn is-primary button is-fullwidth is-medium">
                Join Event <b>&nbsp;{{ shortcode }}</b>
              </div>
              <small v-if="!hostJoinedAsPlayer && joinAsSpectator" class="tos">entering as a spectator</small>
              <small v-if="hostJoinedAsPlayer && joinAsSpectator" class="tos">host cannot join as a spectator</small>
            </template>
          </div>
        </div>
      </transition>
    </div>
    <b-loading :is-full-page="false" :active="redirecting" />
  </section>
</template>
<script>
/* eslint-disable camelcase */
import debounce from 'lodash.debounce'
import emailSpellChecker from '@zootools/email-spell-checker'

import { getUnixTime } from 'date-fns'

import { mapState } from 'vuex'

import getEventIdFromShortcode from '~/queries/getEventIdFromShortcode'
import { getPlayerFromTicket, insertSentEmail, getSentEmails } from '~/queries/playerQueries.gql'
import AvatarControls from '~/components/mixins/AvatarControls'
import addNewPlayer from '~/queries/addNewPlayer'
import { uuidToShort } from '~/common/uuid-shortner'

export default {
  mixins: [ AvatarControls ],
  head: {
    bodyAttrs: {
      class: 'player-join-page'
    }
  },
  auth: false,
  data () {
    return {
      loading: false,
      eventLoading: true,
      checkingforEvent: false,
      typedCode: '',
      typedPassword: '',
      avatar: '/emoji/ghost.svg',
      name: '',
      playerEmail: '',
      suggestion: null,
      userSelectedAvatar: false,
      selectAvatar: false,
      eventToJoin: {},
      hostAsPlayerQuery: '',
      redirecting: false,
      joinAsSpectator: false
    }
  },
  computed: {
    ...mapState([
      'activeEvent',
      'participant',
      'playerLimits',
      'playerOverflow'
    ]),
    joinAsSpectatorString: {
      get () {
        return this.joinAsSpectator ? 'true' : 'false'
      },
      set (val) {
        this.joinAsSpectator = val === 'true'
      }
    },
    shortcode () {
      return this.hasValidCodeInUrl
        ? this.$route.params.code.trim().toLowerCase()
        : this.typedCode.trim().toLowerCase()
    },
    eventId () {
      return this.eventToJoin.id
    },
    shortcodeIsValid () {
      return /[a-zA-Z0-9]{3,10}/.test(this.shortcode)
    },
    hasValidCodeInUrl () {
      return this.$route.params.code && /[a-zA-Z0-9]{3,10}/.test(this.$route.params.code)
    },
    eventFound () {
      return this.eventLoading === false && this.eventToJoin.id
    },
    eventPlayerLimit () {
      if (!this.eventFound) { return null }
      const plan = this.eventToJoin.hostPlan
      return this.playerLimits[plan]
    },
    eventPlayerOverflow () {
      if (!this.eventFound) { return null }
      const plan = this.eventToJoin.hostPlan
      return this.playerOverflow[plan]
    },
    isModerator () {
      if (this.hostJoinedAsPlayer) { return false }
      return this.eventToJoin && this.$auth.loggedIn &&
             this.$auth.user.id === this.eventToJoin.primaryUser
    },
    playersLeft () {
      if (!this.eventFound) { return null }
      return this.eventPlayerLimit - this.eventToJoin.playerCount
    },
    atCapacity () {
      if (!this.eventFound) { return null }
      return this.eventFound ? this.eventToJoin.playerCount >= this.eventPlayerLimit : null
    },
    hasPassword () {
      if (!this.eventFound) { return false }
      return this.eventToJoin?.settings?.requirePassword && this.eventToJoin?.settings?.password?.length >= 3
    },
    hasSpectatorEvent () {
      if (!this.eventFound) { return false }
      return this.eventToJoin?.settings?.useSpectatorEvent
    },
    spectatorEventId () {
      if (!this.eventFound) { return null }
      return this.eventToJoin?.settings?.spectatorEventId
    },
    validPassword () {
      if (!this.hasPassword) { return true }
      const password = this.eventToJoin.settings.password
      return password.replace('cGzc3loWe2aGsEf', '') === btoa(this.typedPassword + 'nacl')
    },
    eventFull () {
      if (!this.eventFound) { return null }
      return this.eventToJoin.playerCount >= this.eventPlayerLimit + this.eventPlayerOverflow
    },
    warning () {
      if (this.eventLoading || !this.shortcodeIsValid || this.checkingforEvent) { return false }

      if (!this.eventFound) { return 'No event found for this code, has the host started the event? If so, try joining again or reloading this page.' }
      if (this.eventFull) { return 'This event is full, no more players can join' }
      if (this.atCapacity) {
        const remainingOverflow = this.playersLeft + this.eventPlayerOverflow
        return 'This event is at capacity, ' + remainingOverflow + ' overflow spot' + this.pluralize(remainingOverflow) + ' remaining for existing players to re-join'
      }

      return false
    },
    hostHasPreviousActivePlayer () {
      return this.activeEvent.id === this.eventId &&
             this.activeEvent.player.name !== 'moderator' &&
             this.activeEvent.player.id
    },
    activePlayer () {
      return this.activeEvent.player
    },
    hostJoinedAsPlayer () {
      return this.$store.state.hostJoinedAsPlayer
    },
    collectPlayerEmails () {
      return this.eventToJoin?.settings?.collectPlayerEmails
    },
    shouldCollectEmail () {
      // !this.eventToJoin?.settings?.useSpectatorEvent &&
      return ['required', 'optional'].includes(this.collectPlayerEmails)
    },
    posthogProps () {
      return {
        event_id: this.activeEvent.id,
        shortcode: this.activeEvent.shortcode,
        player_id: this.activePlayer?.id,
        host_id: this.eventToJoin.primaryUser,
        player_email: this.playerEmail
      }
    }
  },
  watch: {
    eventToJoin (newEvent) {
      this.log('eventToJoin changed', this.eventToJoin)
      if (!newEvent.id || this.isModerator) {
        return
      }

      if (newEvent.id && this.showName) {
        this.checkForPreviousPlayer()
        return
      }

      // There is a valid previous player for this shortcode and event, then go back to the event
      if (this.activePlayer.id && this.activeEvent.shortcode === this.shortcode && this.activeEvent.id === this.eventToJoin.id) {
        this.log(`Joining automatically with a previous player: ${this.activePlayer.id}, ${this.shortcode}`)
        this.$router.push('/event/' + this.shortcode)
      } else {
        this.log('Joining automatically with a new player')
        this.startJoinEvent()
      }

      this.redirecting = true
    },
    hostJoinedAsPlayer (val) {
      if (val && !this.hostHasPreviousActivePlayer && !this.showName) {
        this.log('Joining automatically as a moderator with a new player')
        this.redirecting = true
        this.startJoinEvent()
      }
    }
  },
  created () {
    this.debouncedLoadEvent = debounce(this.loadEvent, 500)
    this.debouncedCheckEmailSpelling = debounce(this.checkEmailSpelling, 400)
  },
  async mounted () {
    // remove host as player
    this.$store.commit('setHostAsPlayer', false)

    if (this.hasValidCodeInUrl) {
      await this.loadEvent()
    } else {
      this.eventLoading = false
    }

    if (this.shortcode === '') { this.checkForPreviousPlayer() }
  },
  methods: {
    async checkForPreviousPlayer () {
      this.log('checking for previous player')
      const noShortcode = this.shortcode === ''
      const matchingCode = this.activeEvent.shortcode === this.shortcode
      const lastActive = getUnixTime(Date.now()) - this.activeEvent.lastActive
      const currentUserId = this.$auth?.user?.id
      const isHostUser = currentUserId === this.eventToJoin.primaryUser

      if (this.$route.query.ticket) {
        try {
          const joined = await this.joinEventFromTicket(this.$route.query.ticket, this.$route.query?.spectator?.toString() === 'true')
          if (joined) { return }
        } catch (e) {
          this.log('error joining event via url ticket', e)
        }
      }

      this.log('skip if any of these are true:', isHostUser, !matchingCode, lastActive > 3600, !this.showName)
      if (isHostUser || (!matchingCode && !noShortcode) || lastActive > 3600 || !this.showName) { return }

      this.log('checking past event to rejoin:', this.shortcode, lastActive)
      const event = await this.getEventId(this.activeEvent.shortcode)
      this.log('EVENT', event)

      this.log('event found, opening rejoin modal')

      const isSpectator = this.activeEvent.id === event?.settings?.spectatorEventId

      // if event is found and still active, ask if they want to rejoin
      if (event && event.id) {
        if (this.activeEvent.id !== event.id && !isSpectator) {
          this.log('event id mismatch, not prompting rejoin')
          return
        }

        // check if this is the host user of the event and don't prompt if so
        if (currentUserId === event.primaryUser) {
          this.log('host user, not prompting rejoin')
          return
        }

        // looks valid, prompt to rejoin
        const spectatorText = isSpectator ? 'spectating in' : 'in'
        const eventPath = isSpectator ? '/spectate/' : '/event/'

        if (noShortcode) {
          this.$buefy.dialog.confirm({
            title: 'Rejoin previous event?',
            message: `You have a player ${spectatorText} an active event — would you like to rejoin the event <b>${this.activeEvent.shortcode.toUpperCase()}</b> with player<span class="inline-player">${this.showAvatar ? `<img src="${this.activePlayer.avatar}">` : ''}${this.activePlayer.name}</span> or join a different event?`,
            confirmText: `Rejoin as player "${this.activePlayer.name}"`,
            cancelText: 'Join a different event',
            canCancel: ['button', 'x', 'outside'],
            onConfirm: () => {
              this.$router.push(eventPath + this.activeEvent.shortcode)
            },
            onCancel: () => {
              // this.$store.commit('clearActiveEvent')
            }
          })
        } else {
          this.$buefy.dialog.confirm({
            title: 'Rejoin with previous player?',
            message: `You already have a player ${spectatorText} this event — would you like to rejoin with player<span class="inline-player">${this.showAvatar ? `<img src="${this.activePlayer.avatar}">` : ''}${this.activePlayer.name}</span> or leave to join as a different player?`,
            confirmText: `Rejoin as player "${this.activePlayer.name}"`,
            cancelText: 'Leave event',
            canCancel: ['button'],
            onConfirm: () => {
              this.$router.push(eventPath + this.activeEvent.shortcode)
            },
            onCancel: () => {
              this.$store.commit('clearActiveEvent')
            }
          })
        }
      }
    },
    joinAsHost () {
      this.$router.push('/event/' + this.shortcode)
    },
    joinHostAsPreviousPlayer () {
      this.log('Joining automatically as a moderator with a previous player', this.activePlayer.id)
      this.$store.commit('setHostAsPlayer')
      this.redirecting = true
      this.$router.push('/event/' + this.shortcode + '?player=true')
    },
    async setHostAsPlayer () {
      await this.$store.commit('clearActiveEvent')
      await this.$store.commit('setHostAsPlayer')
      this.hostAsPlayerQuery = '?player=true'
    },
    startSelectAvatar () {
      this.selectAvatar = true
    },
    pickAvatar (src) {
      this.userSelectedAvatar = true
      this.avatar = src
      this.selectAvatar = false
    },
    checkValidity () {
      return this.$refs.nameInput ? this.$refs.nameInput.isValid && /[a-zA-Z0-9]{3,10}/.test(this.shortcode) : true
    },
    codeUpdated () {
      this.checkingforEvent = true
      if (this.eventToJoin.id) { this.eventToJoin = {} }
      this.debouncedLoadEvent(true)
    },
    async getEventId (shortcode) {
      const { data } = await this.$apollo.query({
        query: getEventIdFromShortcode,
        variables: { shortcode }
      })
      return data.events[0]
    },
    async loadEvent (skipTransition = false) {
      this.log('loading event', this.shortcode)
      if (!this.shortcodeIsValid) { return }
      if (!skipTransition) { this.eventLoading = true }
      const event = await this.getEventId(this.shortcode)

      if (event) {
        event.playerCount = event.participantCount
        this.eventToJoin = event
      }

      this.eventLoading = false
      this.checkingforEvent = false

      if (!this.showName) {
        this.name = this.getAnonymousName()
      }
    },
    async startJoinEvent () {
      if (!this.checkValidity()) {
        this.$buefy.toast.open({ type: 'is-danger', message: 'Please fix errors first!' })
        return
      }

      if (this.name.length < 1) {
        this.$buefy.toast.open({ type: 'is-primary', message: 'Add your name!' })
        this.loading = false; return
      }

      if (this.shortcode.length < 1) {
        this.$buefy.toast.open({ type: 'is-primary', message: 'Add an event code!' })
        this.loading = false; return
      }

      if (this.eventFull) {
        this.$buefy.toast.open({ type: 'is-primary', message: 'Unable to join, this event is full' })
        this.loading = false; return
      }

      if (this.hostJoinedAsPlayer && this.joinAsSpectator) {
        this.$buefy.toast.open({ type: 'is-primary', message: 'Host cannot join as a spectator' })
        this.loading = false; return
      }

      if (!this.validPassword && !this.joinAsSpectator) {
        setTimeout(() => {
          this.$buefy.toast.open({ type: 'is-primary', message: 'That password is incorrect' })
          this.loading = false
        }, 300)
        return
      }

      if (this.shouldCollectEmail && !this.playerEmail && this.collectPlayerEmails === 'required') {
        this.$buefy.toast.open({ type: 'is-primary', message: 'Please enter your email to join' })
        this.loading = false; return
      }

      this.loading = true

      let data
      try {
        const resp = await this.$apollo.query({
          query: getEventIdFromShortcode,
          variables: { shortcode: this.shortcode }
        })
        data = resp.data
      } catch (e) {
        this.$buefy.toast.open({ type: 'is-danger', message: 'A network error has occured, please refresh the page and try again' })
        this.$sentry.captureException(new Error(JSON.stringify({
          msg: 'Player network error trying to join event',
          data,
          shortcode: this.shortcode
        })))
        this.loading = false; return
      }

      if (data.events.length < 1 || !data.events[0] || !data.events[0].id) {
        this.$buefy.toast.open({ type: 'is-primary', message: 'No event found with that code, try again or refresh this page' })
        this.$sentry.captureException(new Error(JSON.stringify({
          msg: 'Player tried to join event but it was not found',
          data,
          shortcode: this.shortcode
        })))
        this.loading = false; return
      }

      this.addPlayerAndJoin()
    },
    async addPlayerAndJoin () {
      this.trackEvent('Player Join Event')
      const eventId = this.joinAsSpectator && this.spectatorEventId ? this.spectatorEventId : this.eventId
      const avatar = this.userSelectedAvatar ? this.avatar : this.showAvatar ? this.allEmoji[0] : null

      const addedParticipant = await this.addNewParticipant(eventId, this.name, avatar)
      const playerId = addedParticipant.id
      const shortcode = this.shortcode

      this.validateAndSendJoinEmail(
        {
          email: this.playerEmail,
          eventId,
          participantId: addedParticipant.id,
          primaryUserId: this.eventToJoin.primaryUser,
          playerId,
          ticket: addedParticipant.ticket,
          shortcode
        }
      )

      const player = {
        id: playerId,
        name: this.name,
        avatar,
        email: this.playerEmail || ''
      }

      const event = {
        id: eventId,
        shortcode: this.shortcode,
        player
      }

      this.posthogCapture('player:event_join', {
        event_id: eventId,
        event_shortcode: this.shortcode,
        player_id: playerId,
        host_id: this.eventToJoin.primaryUser
      })

      if (!this.$auth?.user?.id) {
        try {
          this.$store.commit('setReferral', {
            source: 'player-event-join',
            trf: uuidToShort(this.eventToJoin.primaryUser),
            timestamp: Date.now()
          })
        } catch (e) {
          this.log('error setting referral', e)
        }
      }

      this.$store.commit('setActiveEvent', event)

      if (this.joinAsSpectator && this.spectatorEventId) {
        this.$router.push('/spectate/' + this.shortcode)
      } else {
        this.$router.push('/event/' + this.shortcode)
      }
    },
    async validateAndSendJoinEmail ({ email, eventId, participantId, primaryUserId, playerId, ticket, shortcode }) {
      if (!email) {
        this.log('no email provided, skipping validation')
        return
      }

      let validateEmail
      try {
        // '/backend/.netlify/functions/validate-email',
        validateEmail = await this.$axios.post(process.env.SITE_URL + '/api/validate-email', {
          email, eventId, participantId, primaryUserId
        })
        this.log('email validation', validateEmail)
      } catch (e) {
        this.log('error validating email', e)
      }
      const validation = validateEmail?.data?.validationResponse || {}
      const participantEmailId = validateEmail?.data?.participantEmailId
      const rejoinLink = `${process.env.SITE_URL}/${shortcode}?ticket=${ticket}&spectator=${this.joinAsSpectator}`

      let avatarUnicode
      try { avatarUnicode = this.getAvatarUnicode(this.avatar) } catch (_) {}
      const playerTag = avatarUnicode ? avatarUnicode + ' ' + this.name : this.name

      this.posthogCapture('player:email_add', this.posthogProps)

      if (validation.isValid === true) {
        this.log('email is valid, sending join email', validateEmail?.data)
        this.sendEmail('40881079', 'event-join', {
          playerTag,
          player: this.name,
          eventId,
          participantId: playerId,
          participantEmailId,
          rejoinLink
        })
      } else {
        this.log('email not valid, skipping send', validateEmail)
      }
    },
    checkEmailSpelling () {
      const suggestion = emailSpellChecker.run({ email: this.playerEmail })
      if (suggestion) {
        this.suggestion = suggestion.full
      } else {
        this.suggestion = null
      }
    },
    setSuggestedEmail () {
      this.playerEmail = this.suggestion
      this.suggestion = null
    },
    async sendEmail (templateId, internalKey, params) {
      // this.log('SENDING EMAIL', templateId, internalKey, params)
      const checkSent = await this.$apollo.query({
        query: getSentEmails,
        variables: { participantEmailId: params.participantId }
      })

      if (checkSent.data.sentEmails.length > 0 && checkSent.data.sentEmails.some(email => email.name === internalKey)) {
        this.log('email already sent', internalKey)
        return
      }

      let emailSent = false

      try {
        const email = {
          to: this.playerEmail,
          templateId,
          tag: internalKey,
          variables: params,
          eventId: this.eventId
        }

        const resp = await this.$axios.post(
          process.env.SITE_URL + '/api/send-join-event-email',
          // process.env.SITE_URL + '/backend/.netlify/functions/send-join-event-email',
          email
        )
        this.log('EMAIL SENT', resp)
        emailSent = true

        await this.$apollo.mutate({
          mutation: insertSentEmail,
          variables: {
            email: this.playerEmail,
            name: internalKey,
            participantEmailId: params.participantEmailId,
            participantId: params.participantId,
            status: 'sent'
          }
        })
      } catch (e) {
        this.log('error sending email message', e.message, e)
      }

      const posthogProps = { ...this.posthogProps, email_template: internalKey, email_status: emailSent ? 'sent' : 'error' }
      this.posthogCapture('player:email_sent', posthogProps)
    },

    async addNewParticipant (eventId, name, avatar) {
      const { data: { insert_participants } } = await this.$apollo.mutate({
        mutation: addNewPlayer,
        variables: { eventId, name, avatar }
      })
      return insert_participants.returning[0]
    },

    async joinEventFromTicket (ticket, spectator = false) {
      const eventId = spectator ? this.spectatorEventId : this.eventId
      const { data } = await this.$apollo.query({
        query: getPlayerFromTicket,
        variables: { eventId, ticket }
      })

      if (data.participants.length > 0) {
        this.$store.commit('clearActiveEvent')
        this.log('player found with ticket', data.participants[0])

        if (data?.participants[0]?.isRemoved) {
          this.log('player is removed, not prompting rejoin')
          this.$buefy.toast.open('You have been removed from this event')
          this.$router.push('/event/' + this.shortcode)
          return
        }

        const player = {
          id: data.participants[0].id,
          name: data.participants[0].name,
          avatar: data.participants[0].avatar,
          email: data.participants[0].email
        }

        const eventObj = {
          id: eventId,
          shortcode: this.shortcode,
          player
        }
        this.$store.commit('setActiveEvent', eventObj)

        this.posthogCapture('player:rejoin_from_link', this.posthogProps)

        // lets skip the check then
        if (spectator) {
          this.$router.push('/spectate/' + this.shortcode)
        } else {
          this.$router.push('/event/' + this.shortcode)
        }
        return true
      } else {
        this.log('no player found with ticket', ticket)
        this.$router.push('/go/')
        return false
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.control:deep(.radio.button) {
  border: 1px solid #e1e4e5;
}

small.tos {
  opacity: .8;
  text-align: center;
  margin-top: 0px;
  width: 100%;
  display: block;
  height: 0px;
  position: relative;
  top: 5px;
}

.avatar-svg-wrapper {
  background-color: #646d7d;
  width: 3.3em;
  height: 3.3em;

  .avatar-svg-icon {
    background-color: white;
  }
}

.is-text.prev-player {
  margin-bottom: -20px;
}
.join-event {
  background-image: linear-gradient( -39.6deg,  rgba(253,199,141,1) 11.3%, rgba(249,143,253,1) 100.2% );

  &.event-loading {
    // white linear gradient
    background-image: linear-gradient(0, #fff 0%, #fff 100%);
  }
  &.business-style {
    // background-image: linear-gradient(-39.6deg, rgb(123, 123, 123) 11.3%, rgb(116, 116, 161) 100.2%);
    background-image: linear-gradient(-39.6deg, rgb(102, 112, 139) 11.3%, rgb(116, 116, 161) 100.2%);

    .unselected {
      .avatar-svg-wrapper {
        opacity: 0.05;
      }
      .avatar-svg-icon {
        opacity: 0;
      }
    }
  }
}

.is-small {
  font-size: .85em;
}

.logo {
  width:100%;
  text-align:center;
  height:50px;
  margin: 20px auto 20px;
}

.form-wrap.login {
  box-shadow: 0px 10px 55px rgba(0,0,0,.2);
  padding: 25px 35px 50px;
  margin: 0px 10px;
  max-width: 328px;

  &.redirecting {
    padding-bottom: 0;
  }

  p, .buttons {
    max-width: 258px;
  }
}

.name-field {
  margin-bottom: 0;
}

.suggestion {
  display: block;
  background-color: rgb(243, 230, 153);
  color: #444;
  padding: 8px 16px;
  border-radius: 8px;
  margin-top: 10px;
  font-size: 14px;
  cursor: pointer;
  margin-bottom: 24px;
}

.title.event-code {
  text-align: center;
  margin-top: -20px;
  margin-bottom: 30px;

  b {
    text-transform: uppercase;
    opacity: .9;
  }
}

.join-btn b {
  text-transform: uppercase;
}

.title.join-event {
  margin: -10px auto 20px;
  width: 50%;
  color: white;
  padding: 10px;
  border-radius: 4px;
}

.current-avatar {
  width: 100%;
  margin: 0 auto 0.75rem;
  text-align: center;
  border-radius: 4px;
  background-color: #fefefe;
  position: relative;
  padding: 25px 50px;
  border: 1px solid rgba(0,0,0,.1);

  .avatar-svg-wrapper {
    width: 7em;
    height: 7em;
    margin: 0 auto;
  }

    &.unselected {

    .avatar {
      opacity: .8;
    }

    &:after {
      pointer-events: none;
      content: '+';
      position: absolute;
      width: 100%;
      height: 100%;
      top:0; bottom: 0;
      left: 0; right: 0;
      font-size: 3em;
      line-height: 3em;
      padding-bottom: .2em;
      margin: 0;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      color: rgba(0,0,0,.1);
    }
  }
}

.avatar-select {
  position: fixed;
  padding: 30px 48px 100px 50px;
  text-align: center;
  top: 0;
  left: 0;
  background-color: white;
  width: 100%;
  height: 100%;
  z-index: 100;
  overflow-y: scroll;

  .title {
    margin-top: -5px;
    margin-bottom: 40px;
  }

  .close {
    position: absolute;
    top: 5px;
    right: 15px;
    font-size: 1.5em;
    opacity: .3;
  }

  .avatars{
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(50px, 1fr));
    grid-template-rows: repeat(auto-fill, 50px, 1fr);
    gap: 30px;

  }
}
</style>
